document.addEventListener('DOMContentLoaded', function () {

    // Custom scroll function with offset
    function scrollToElementWithOffset(element, offset = 100) {
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

    // Scroll to dropdown when clicking on country links in Costing Tool
    document.querySelectorAll('.quick-access-country-list ol li a').forEach((link) => {
        link.addEventListener('click', function (event) {
            sessionStorage.setItem('scrollToDropdown', 'true'); // Store flag before navigation
        });
    });

    document.querySelectorAll('.scroll-country-list ul li a').forEach((link) => {
        link.addEventListener('click', function () {
            sessionStorage.setItem('scrollToDropdown', 'true');
        });
    });

    if (sessionStorage.getItem('scrollToDropdown') === 'true') {
        sessionStorage.removeItem('scrollToDropdown');
        setTimeout(() => {
            document.getElementById('countries-dropdown-select').scrollIntoView({ behavior: 'smooth' });
        }, 500);
    }

    // Scroll to country buttons when clicking on country links in Factsheets
    document.querySelectorAll('.country-profiles__categories__country ul li a').forEach((link) => {
        link.addEventListener('click', function () {
            sessionStorage.setItem('scrollToCountryButtons', 'true');
        });
    });

    document.querySelectorAll('#countryList li a').forEach((link) => {
        link.addEventListener('click', function () {
            sessionStorage.setItem('scrollToCountryButtons', 'true');
        });
    });

    if (sessionStorage.getItem('scrollToCountryButtons') === 'true') {
        sessionStorage.removeItem('scrollToCountryButtons');
        setTimeout(() => {
            const countryButtons = document.querySelector('.country__with__buttons__grid');
            if (countryButtons) {
                scrollToElementWithOffset(countryButtons, 90);
            }
        }, 500);
    }
});